import React from "react";

export default function Footer() {
  return (
    <div className="Footer">
      <p className="code-link">
        <a
          href="https://github.com/lndslm/weather-react-app"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open-source code
        </a>{" "}
        by{" "}
        <a
          href="https://www.linkedin.com/in/linda-salim-40641364/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Linda Salim
        </a>
      </p>
    </div>
  );
}
